// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2XaXo","focus":"Button_focus__2rDT6","primary":"Button_primary__YFjMA","success":"Button_success__zeZvv","error":"Button_error__lVnOY"};